import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import useSWR from "swr";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { DialogContent, DialogTitle, DialogActions, Button, withStyles, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Flex, AjaxBlackout, createSnackbar, createSnackbarAPIException, Loading } from "../../../../_common";

function ModalEnriquecer({ classes, leadsValidos, leadsInvalidos, callback = () => null }) {
  const intl = useIntl();
  const history = useHistory();
  const [mostrarListaLeadsInvalidos, setMostrarListaLeadsInvalidos] = useState(false);
  const { data: credito, isValidating } = useSWR("/api/pipeline/Searching/Saldo");

  const handleConfirmar = () => {
    AjaxBlackout.Show();
    const payload = leadsValidos.map(lead => ({
      id: lead.id,
      cnpj: lead.cpfCnpj,
    }));
    axios
      .post(`/api/pipeline/EnriquecerLeads/Processar`, payload)
      .then(({ data }) => {
        createSnackbar(intl.formatMessage({ defaultMessage: "Leads enviados para enriquecimento" }));
        callback(data);
      })
      .catch(error => {
        createSnackbarAPIException(error);
      })
      .finally(() => {
        AjaxBlackout.Hide();
        callback();
      });
  };

  const handleContratar = () => {
    AjaxBlackout.Show();
    history.push("/spotter/conta/mais-recursos");
  };

  return (
    <Loading isLoading={isValidating}>
      <DialogTitle>
        {credito > 0
          ? intl.formatMessage({ defaultMessage: "Deseja enriquecer estes leads?" })
          : intl.formatMessage({ defaultMessage: "Créditos insuficientes" })}
      </DialogTitle>
      <DialogContent id="dialog-content-modal-enriquecimento-massa">
        {credito === 0 && (
          <Flex flexDirection="column">
            <Typography>
              {intl.formatMessage({
                defaultMessage:
                  "Você não possui créditos suficientes para enriquecer o lead no momento. Você pode aguardar a renovação dos seus créditos no próximo mês ou fazer upgrade do seu plano do Searching clicando no botão abaixo.",
              })}
            </Typography>
          </Flex>
        )}
        {credito > 0 && (
          <Flex flexDirection="column">
            <Typography>
              {intl.formatMessage({
                defaultMessage:
                  "Você realizará o enriquecimento dos leads selecionados. Será cobrado <b>1 crédito</b> do seu plano do Searching.",
              })}
            </Typography>
            <Typography style={{ color: "#00000099", marginTop: 16 }}>
              {intl.formatMessage(
                {
                  defaultMessage: "Créditos consumidos: 1 de {valor}.",
                },
                { valor: credito }
              )}
            </Typography>
            {leadsInvalidos.length > 0 && (
              <Flex flexDirection="column">
                <Typography className={classes.labelInvalidos}>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        "{leadsInvalidos} dos {total} leads selecionados não tem CNPJ, logo não serão enriquecidos.",
                    },
                    { leadsInvalidos: leadsInvalidos.length, total: leadsValidos.length + leadsInvalidos.length }
                  )}
                </Typography>
                <Button
                  id="btn-ver-leads-invalidos"
                  color="primary"
                  className={!mostrarListaLeadsInvalidos ? classes.btnVerLeads : classes.btnEsconderLeads}
                  onClick={() => setMostrarListaLeadsInvalidos(!mostrarListaLeadsInvalidos)}
                >
                  {!mostrarListaLeadsInvalidos
                    ? intl.formatMessage({ defaultMessage: "Ver leads sem CNPJ" })
                    : intl.formatMessage({ defaultMessage: "Esconder leads sem CNPJ" })}
                  <ArrowDropDownIcon style={{ transform: mostrarListaLeadsInvalidos ? "rotate(180deg)" : "none" }} />
                </Button>
                {mostrarListaLeadsInvalidos && (
                  <Flex flexDirection="column" className={classes.containerLista}>
                    <ul>
                      {leadsInvalidos.map(item => (
                        <li key={item.id}>
                          <Typography>{item.nome}</Typography>
                        </li>
                      ))}
                    </ul>
                  </Flex>
                )}
              </Flex>
            )}
          </Flex>
        )}
      </DialogContent>
      <DialogActions id="dialog-actions-modal-enriquecimento-massa">
        <Button onClick={() => callback()}>{intl.formatMessage({ defaultMessage: "Cancelar" })}</Button>
        {credito ? (
          <Button
            id="btn-confirmar-em-massa"
            disabled={leadsValidos.length === 0}
            color="primary"
            onClick={handleConfirmar}
          >
            {intl.formatMessage({ defaultMessage: "Confirmar" })}
          </Button>
        ) : (
          <Button id="btn-contratar-em-massa" color="primary" onClick={handleContratar}>
            {intl.formatMessage({ defaultMessage: "Quero contratar" })}
          </Button>
        )}
      </DialogActions>
    </Loading>
  );
}

ModalEnriquecer.propTypes = {
  leadsValidos: PropTypes.array,
  leadsInvalidos: PropTypes.array,
  callback: PropTypes.func,
};

export default withStyles({
  labelInvalidos: {
    fontWeight: 700,
    marginTop: 16,
  },
  btnVerLeads: {
    marginTop: 16,
    width: 197,
  },
  btnEsconderLeads: {
    marginTop: 16,
    width: 240,
  },
  containerLista: {
    marginTop: 16,
    border: "1px #00000023 solid",
    maxHeight: 280,
    overflow: "auto",
    borderRadius: 4,
  },
})(ModalEnriquecer);
